import { render, staticRenderFns } from "./CalendarItem.vue?vue&type=template&id=6487acfe&scoped=true&"
import script from "./CalendarItem.vue?vue&type=script&lang=js&"
export * from "./CalendarItem.vue?vue&type=script&lang=js&"
import style0 from "./CalendarItem.vue?vue&type=style&index=0&id=6487acfe&prod&scoped=true&lang=css&"
import style1 from "./CalendarItem.vue?vue&type=style&index=1&id=6487acfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6487acfe",
  null
  
)

export default component.exports